import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { NotificationProvider } from './context/NotificationContext';
import ToastContainer from './components/ToastNotification';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-tech-bg flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 rounded bg-tech-surface border border-tech-border glow-accent-sm flex items-center justify-center mb-4 mx-auto animate-pulse-glow">
            <svg className="w-8 h-8 text-tech-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17.98 10.804V12.18c0 1.128.48 2.11 1.237 2.747l2.963 2.478c.77.646.77 1.882 0 2.528L19.7 21.02c-.757.637-1.237 1.62-1.237 2.748v1.436" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M6.02 13.196V11.82c0-1.128-.48-2.11-1.237-2.747L.82 6.595c-.77-.646-.77-1.882 0-2.528L4.298 1.88c.757-.637 1.237-1.62 1.237-2.748V.982" />
            </svg>
          </div>
          <p className="text-tech-textMuted text-sm font-mono">INITIALIZING SYSTEM...</p>
        </div>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-tech-bg flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 rounded bg-tech-surface border border-tech-border glow-accent-sm flex items-center justify-center mb-4 mx-auto animate-pulse-glow">
            <svg className="w-8 h-8 text-tech-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17.98 10.804V12.18c0 1.128.48 2.11 1.237 2.747l2.963 2.478c.77.646.77 1.882 0 2.528L19.7 21.02c-.757.637-1.237 1.62-1.237 2.748v1.436" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M6.02 13.196V11.82c0-1.128-.48-2.11-1.237-2.747L.82 6.595c-.77-.646-.77-1.882 0-2.528L4.298 1.88c.757-.637 1.237-1.62 1.237-2.748V.982" />
            </svg>
          </div>
          <p className="text-tech-textMuted text-sm font-mono">LOADING...</p>
        </div>
      </div>
    );
  }

  return user ? <Navigate to="/dashboard" /> : children;
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <NotificationProvider>
          <Router>
            <Routes>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              path="/register"
              element={
                <PublicRoute>
                  <Register />
                </PublicRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          </Router>
          <ToastContainer />
        </NotificationProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
